export default {
  back: 'Înapoi la meniu',
  menu: 'Meniu',
};
